export default __webpack_public_path__ + "static/media/pj-jogo-memoria.28eda661.png";